export default __webpack_public_path__ + "static/media/cancel.0c3f72f9.svg";